/* eslint-disable */

"use client";
import React, { useState, useEffect, useRef, useCallback } from "react";
import chair from "../../assets2/images/Chair.svg";
import standing from "../../assets2/icons/Standing.png";
import { MdDone } from "react-icons/md";
import houses from "../../assets2/images/houses.svg";
import { IoMdHeart, IoMdHeartEmpty } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import NewFavoriteFolderModal from "../myFav/NewFavoriteFolderModal";
import AddedFavoriteModal from "../myFav/AddedFavoriteModal";
import { useDispatch, useSelector } from "react-redux";
import { getUser } from "../../lib/apis";
import { toast } from "react-toastify";
import { getEnquiries } from "../../lib/apis";
import Coupon from "../../assets2/icons/Coupon.svg";
import { base_URL } from "../../config/config";
import { DeviceType } from "../../hooks/deviceType";
import { useQuery } from "@tanstack/react-query";
import { LuDot, LuPin } from "react-icons/lu";
import axios from "axios";
import VenueCard from "../shared/card/venue/VenueCard";
import {
	addVenue,
	setSelectedVenues,
} from "../../store/features/bulkEnquirySlice";
import { queueImpression } from "../../utils/impressionQueue";

const DetailComponent = ({
	data,
	isCompareMode,
	isSelected,
	onSelect,
	breadcrumbPath = [],
	priority = false,
}) => {
	const cardRef = useRef();
	const user = useSelector((state) => state.auth.user);
	const dispatch = useDispatch();
	const bulkEnquiry = useSelector((state) => state.bulkEnquiry);
	const deviceType = DeviceType();
	const favoriteVenues =
		user?.favoritesFolder?.map((folder) => folder.venues).flat() || [];
	const [newFolder, setNewFolder] = useState(false);
	const [favItem, setFavItem] = useState(null);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isModalAddedOpen, setIsModalAddedOpen] = useState(false);
	const [isSubmittedEnquiry, setIsSubmittedEnquiry] = useState(false);
	const hasOffers =
		data?.offersAndPackages?.length > 0 &&
		data?.offersAndPackages?.some((offer) => {
			const currentDate = new Date();
			const endDate = new Date(offer.endDate);
			return endDate >= currentDate;
		});

	const [minSpendPricing, setMinSpendPricing] = useState(null);
	const [minSpendPerPerson, setMinSpendPerPerson] = useState(null);
	const [venueRental, setVenueRental] = useState(null);
	const getFavoriteFolder = async () => {
		try {
			const response = await fetch(
				`${base_URL}/api/auth/get-folders/${user?._id}`
			);
			if (!response.ok) {
				console.log("Failed to fetch Venues");
				return;
			}
			const data = await response.json();
			refetchFav1();
			return data.folders;
		} catch (err) {
			console.log(err);
		}
	};
	const { folders, refetch } = useQuery({
		queryKey: ["favoriteFolder", user?._id],
		queryFn: getFavoriteFolder,
		enabled: !!user?._id, // Ensure the query only runs when these values are available
	});
	const calculateMinSpendFromSelectedOptions = () => {
		if (data?.pricing) {
			let selectedOptions = [];
			if (data?.pricing?.["Minimum Spend Pricing"]) {
				selectedOptions = [
					...selectedOptions,
					{
						type: "Minimum Spend Pricing",
						details: data?.pricing["Minimum Spend Pricing"][0],
					},
				];
			}
			if (data?.pricing?.["Venue Rental"]) {
				selectedOptions = [
					...selectedOptions,
					{ type: "Venue Rental", details: data?.pricing["Venue Rental"][0] },
				];
			}
			if (data?.pricing?.["Min spend per person"]) {
				selectedOptions = [
					...selectedOptions,
					{
						type: "Min spend per person",
						details: data?.pricing["Min spend per person"][0],
					},
				];
			}
			let minSpendPricing = null;
			let venueRental = null;
			let minSpendPerPerson = null;
			let hasMinimumSpendPricing = false;

			selectedOptions.forEach((option) => {
				const minSpendValue = Number(option?.details?.minSpend || undefined);
				if (
					option?.details?.type === "Venue Rental" &&
					option?.details?.minSpend
				)
					venueRental = option?.details?.minSpend;

				if (minSpendValue !== undefined && !Number.isNaN(minSpendValue)) {
					switch (option.type) {
						case "Minimum Spend Pricing":
							hasMinimumSpendPricing = true; // Flag that "Minimum Spend Pricing" exists
							minSpendPricing =
								minSpendPricing === null
									? minSpendValue
									: Math.min(minSpendPricing, minSpendValue);
							break;

						case "Venue Rental":
							// Only use Venue Rental if Minimum Spend Pricing isn't available
							venueRental =
								venueRental === null
									? minSpendValue
									: Math.min(venueRental, minSpendValue);
							break;

						case "Min spend per person":
							minSpendPerPerson =
								minSpendPerPerson === null
									? minSpendValue
									: Math.min(minSpendPerPerson, minSpendValue);
							break;

						default:
							break;
					}
				}
			});

			// Set the calculated minimum spend values to the state
			setMinSpendPricing(minSpendPricing);
			setMinSpendPerPerson(minSpendPerPerson);
			setVenueRental(venueRental);
		} else {
			// If no selected options are present, reset all values to null
			setMinSpendPricing(null);
			setMinSpendPerPerson(null);
			setVenueRental(null);
		}
	};

	// Call this function in useEffect to update the values whenever formData changes
	useEffect(() => {
		calculateMinSpendFromSelectedOptions();
	}, [data]);

	const handleImpression = useCallback(() => {
		queueImpression({
			venueId: data?._id,
			vendorId: data?.vendorId,
			date: new Date().toISOString(),
			deviceCategory: deviceType,
			impressions: 1,
			venueName: `${data?.basicDetails?.venueName}, ${data?.basicDetails?.hotelName}`,
			customerId: user?._id || "anonymous",
		});
	}, [data?._id]);

	useEffect(() => {
		const el = cardRef.current;
		if (!el) return;

		// Fires at 50% visibility for impression analytics
		const impressionObs = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) handleImpression();
			},
			{ threshold: 0.5 }
		);

		impressionObs.observe(el);

		return () => {
			impressionObs.disconnect();
		};
	}, [data?._id, handleImpression]);

	const setEnquiryData = async () => {
		const enquiriesData = await getEnquiries();
		const venueEnquiries = enquiriesData?.venueEnquiries;
		const enquiryId = venueEnquiries?.map((enquiry) => enquiry.venueId);
		if (enquiryId?.includes(data._id)) {
			setIsSubmittedEnquiry(true);
		}
	};

	useEffect(() => {
		if (user) setEnquiryData();
	}, []);
	const navigate = useNavigate();
	const isFavorite = favoriteVenues.some(
		(favorite) => favorite?.id === data?._id
	);

	const slugify = (str) =>
		str
			?.toLowerCase() // make lowercase
			.replace(/[^a-z0-9]+/g, "-") // replace spaces/special chars with -
			.replace(/(^-|-$)/g, "");

	const handleViewPreviewDetails = () => {
		const cf = "hpv";
		const venueId = data?._id;
		const slug = slugify(data?.basicDetails?.venueName);

		const updatedPath =
			breadcrumbPath?.length > 1
				? [...breadcrumbPath, { name: data?.basicDetails?.venueName }]
				: breadcrumbPath;

		const url = `/preview/${cf}/${venueId}/${slug}`;

		const newWindow = window.open(url, "_blank");

		if (updatedPath) {
			sessionStorage.setItem("breadcrumbPath", JSON.stringify(updatedPath));
		}

		if (newWindow) newWindow.focus();
	};

	useEffect(() => {
		if (user?._id) getUserInfo();
	}, [user?._id]);

	const getUserInfo = async () => {
		const userInfo = await getUser(user?._id);
		let venuesAndStay = [];
		userInfo?.favoritesFolder?.forEach((folder) => {
			if (folder.venues.length > 0) {
				venuesAndStay = [...venuesAndStay, ...folder?.venues];
			}
		});
		console.log(userInfo);
		return venuesAndStay;
	};
	const { data: userFavorites, refetch: refetchFav1 } = useQuery({
		queryKey: ["userFavorites1"],
		queryFn: getUserInfo,
		enabled: !!user?._id,
	});

	// handling add/remove favorite
	const handleClickFavorite = async (itemId) => {
		if (!itemId) return;

		if (!user) {
			return toast.error("Please login first");
		}

		const isFavorited =
			userFavorites &&
			userFavorites.find((favorite) => favorite?.id === itemId);

		if (isFavorited) {
			refetch();
			refetchFav1();
			// If already favorited, remove it
			await removeFavorite(itemId);
		} else {
			// If not favorited, add it
			refetch();
			refetchFav1();
			setFavItem(itemId);
			user?.favoritesFolder?.length > 0
				? setIsModalAddedOpen(true)
				: setIsModalOpen(true);
		}
	};

	// remove favorite
	const removeFavorite = async (itemId) => {
		try {
			const response = await axios.post(
				`${base_URL}/api/favorite/remove-favorite`,
				{
					userId: user._id,
					itemId,
				}
			);

			if (response?.data?.success) {
				toast.success("Removed from favorites");
				refetchFav1();
				refetch();
			} else {
				toast.error("Failed to remove from favorites");
			}
		} catch (error) {
			console.error(error);
			toast.error("An error occurred while removing from favorites");
		}
	};
	const getVenuActivity = (data) => {
		if (data?.additionalDetails?.venueSetting?.length === 1) {
			if (data?.additionalDetails?.venueSetting[0] === "Indoor + Outdoor")
				return "Indoor & Outdoor";
			else return data?.additionalDetails?.venueSetting[0];
		} else if (data?.additionalDetails?.venueSetting?.length > 1)
			return data?.additionalDetails?.venueSetting.join(" & ");
		else return "Indoor & Outdoor";
	};

	const favoriteOverlayComp = () => {
		return (
			<div
				className="bg-white absolute top-1 right-5 p-1.5 rounded-full cursor-pointer"
				onClick={(e) => {
					e.stopPropagation();
					handleClickFavorite(data?._id, 0);
				}}
			>
				{userFavorites &&
				userFavorites?.find((favorite) => favorite?.id === data?._id) ? (
					<IoMdHeart className="text-primary" />
				) : (
					<IoMdHeartEmpty className="text-primary" />
				)}
			</div>
		);
	};

	const CheckboxOverlay = ({ data, handleCheckboxClick }) => {
		const selectedVenues = bulkEnquiry?.selectedVenues || [];
		const selectedIds = selectedVenues.map((venue) => venue._id);

		return (
			<>
				{bulkEnquiry?.isBulkEnquiryOpen && (
					<div
						className="absolute top-1 left-5 bg-white p-1.5 rounded-full shadow-md cursor-pointer flex items-center justify-center hover:scale-105 transition-transform"
						onClick={(e) => {
							e.stopPropagation();
							handleCheckboxClick(data?._id);
						}}
					>
						<input
							type="checkbox"
							checked={selectedIds.includes(data?._id)}
							readOnly
							className="w-[14px] h-[14px] accent-primary cursor-pointer"
						/>
					</div>
				)}
			</>
		);
	};

	const submittedEnquiryOverlayComp = () => {
		return (
			<>
				{isSubmittedEnquiry && (
					<div className="bg-[#EAF9F7] flex justify-center items-center py-[2px] px-2 h-[25px] text-sm text-[#039f8d] absolute top-3 left-3 rounded-md cursor-pointer">
						<span>
							<MdDone className="text-md text-[#039f8d]" />
						</span>
						Enquiry Sent
					</div>
				)}
			</>
		);
	};

	const offerOverlayComp = () => {
		return (
			<>
				{hasOffers && (
					<div className="bg-[#fff6e6] flex justify-center items-center py-[2px] px-2 h-[25px] text-sm text-[#4B3A19] absolute bottom-3 right-3 rounded-md cursor-pointer">
						<span className="mr-1">
							<img src={Coupon} alt="" />
						</span>
						Offer Available
					</div>
				)}
			</>
		);
	};

	const pinnedOverlayComp = () => {
		if (!data?.isPinned) return null;
		return (
			<div className="absolute bottom-3 left-3 bg-[#E8F9F7] text-[#0D9E8E] p-1.5 rounded-full shadow-sm">
				<LuPin size={13} strokeWidth={2.5} className="-rotate-45" />
			</div>
		);
	};
	return (
		<>
			{newFolder && (
				<NewFavoriteFolderModal
					isOpen={newFolder}
					onClose={() => {
						setNewFolder(false);
						refetchFav1();
					}}
					itemId={favItem}
					type={"venue"}
					refetch={refetch}
				/>
			)}
			{user?.favoritesFolder?.length > 0 ? (
				<AddedFavoriteModal
					setNewFolder={setNewFolder}
					isOpen={isModalAddedOpen}
					refetch={refetch}
					itemId={favItem}
					data={folders}
					type={"venue"}
					onClose={() => {
						setIsModalAddedOpen(false);
						refetchFav1();
					}}
				/>
			) : (
				<NewFavoriteFolderModal
					isOpen={isModalOpen}
					itemId={favItem}
					refetch={refetch}
					type={"venue"}
					onClose={() => {
						setIsModalOpen(false);
						refetchFav1();
					}}
				/>
			)}

			<VenueCard
				ref={cardRef}
				onClick={() => {
					handleViewPreviewDetails(
						data?._id,
						`${data?.basicDetails?.venueName}, ${data?.basicDetails?.hotelName}`,
						user?._id
					);
				}}
			>
				<VenueCard.Slider images={data?.imagesAndVideos?.images} priority={priority}>
					{/**@Overlays */}
					<>
						<CheckboxOverlay
							data={data}
							handleCheckboxClick={() => dispatch(addVenue(data))}
						/>
						{favoriteOverlayComp()}
						{/* {submittedEnquiryOverlayComp()} */}
						{offerOverlayComp()}
						{pinnedOverlayComp()}
					</>
				</VenueCard.Slider>
				<VenueCard.Details>
					<VenueCard.VenueName>
						{data?.basicDetails?.venueName || "Undefined"},{" "}
						{data?.basicDetails?.hotelName || "Undefined"}
					</VenueCard.VenueName>
					<VenueCard.Location>
						{data?.location?.city || "Undefined"},{" "}
						{data?.location?.area || "Undefined"}
					</VenueCard.Location>
					<VenueCard.Icons
						chair={chair}
						standing={standing}
						sittingCapacity={data?.capacity.sitting}
						standingCapacity={data?.capacity.standing}
					/>
					<VenueCard.Activity
						houses={houses}
						venueRepresent={data?.venueType?.venueRepresent}
						venueSetting={getVenuActivity(data)}
					/>
					<div
						className={`flex items-start w-full justify-between ${
							isCompareMode && "pb-7"
						} `}
					>
						<VenueCard.Pricing
							minSpendPricing={venueRental ? venueRental : minSpendPricing}
							showGuests={minSpendPerPerson}
							minSpendPerPerson={minSpendPerPerson}
							showVenueRental={venueRental ? true : false}
						/>
					</div>
				</VenueCard.Details>
			</VenueCard>
		</>
	);
};

export default DetailComponent;
